export type CountryTerritory = {
  name: string
  regions: string[]
  iso2: string
  dialCode: string
  format?: string | null
  priority?: number
  areaCodes?: string[]
}

export const countriesAndTerritories: CountryTerritory[] = [
  {
    name: 'Afghanistan',
    regions: ['asia'],
    iso2: 'af',
    dialCode: '93',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Albania',
    regions: ['europe'],
    iso2: 'al',
    dialCode: '355',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Algeria',
    regions: ['africa', 'north-africa'],
    iso2: 'dz',
    dialCode: '213',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'American Samoa',
    regions: ['oceania'],
    iso2: 'as',
    dialCode: '1684',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Andorra',
    regions: ['europe'],
    iso2: 'ad',
    dialCode: '376',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Angola',
    regions: ['africa'],
    iso2: 'ao',
    dialCode: '244',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Anguilla',
    regions: ['america', 'carribean'],
    iso2: 'ai',
    dialCode: '1264',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Antigua and Barbuda',
    regions: ['america', 'carribean'],
    iso2: 'ag',
    dialCode: '1268',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Argentina',
    regions: ['america', 'south-america'],
    iso2: 'ar',
    dialCode: '54',
    format: '(..) ........',
    priority: 0,
    areaCodes: [
      '11',
      '221',
      '223',
      '261',
      '264',
      '2652',
      '280',
      '2905',
      '291',
      '2920',
      '2966',
      '299',
      '341',
      '342',
      '343',
      '351',
      '376',
      '379',
      '381',
      '3833',
      '385',
      '387',
      '388'
    ]
  },
  {
    name: 'Armenia',
    regions: ['asia', 'ex-ussr'],
    iso2: 'am',
    dialCode: '374',
    format: '.. ......',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Aruba',
    regions: ['america', 'carribean'],
    iso2: 'aw',
    dialCode: '297',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Australia',
    regions: ['oceania'],
    iso2: 'au',
    dialCode: '61',
    format: '(..) .... ....',
    priority: 0,
    areaCodes: ['2', '3', '4', '7', '8', '02', '03', '04', '07', '08']
  },
  {
    name: 'Austria',
    regions: ['europe', 'eu-union'],
    iso2: 'at',
    dialCode: '43',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Azerbaijan',
    regions: ['asia', 'ex-ussr'],
    iso2: 'az',
    dialCode: '994',
    format: '(..) ... .. ..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Bahamas',
    regions: ['america', 'carribean'],
    iso2: 'bs',
    dialCode: '1242',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Bahrain',
    regions: ['middle-east'],
    iso2: 'bh',
    dialCode: '973',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Bangladesh',
    regions: ['asia'],
    iso2: 'bd',
    dialCode: '880',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Barbados',
    regions: ['america', 'carribean'],
    iso2: 'bb',
    dialCode: '1246',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Belarus',
    regions: ['europe', 'ex-ussr'],
    iso2: 'by',
    dialCode: '375',
    format: '(..) ... .. ..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Belgium',
    regions: ['europe', 'eu-union'],
    iso2: 'be',
    dialCode: '32',
    format: '... .. .. ..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Belize',
    regions: ['america', 'central-america'],
    iso2: 'bz',
    dialCode: '501',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Benin',
    regions: ['africa'],
    iso2: 'bj',
    dialCode: '229',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Bermuda',
    regions: ['america', 'north-america'],
    iso2: 'bm',
    dialCode: '1441',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Bhutan',
    regions: ['asia'],
    iso2: 'bt',
    dialCode: '975',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Bolivia',
    regions: ['america', 'south-america'],
    iso2: 'bo',
    dialCode: '591',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Bosnia and Herzegovina',
    regions: ['europe', 'ex-yugos'],
    iso2: 'ba',
    dialCode: '387',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Botswana',
    regions: ['africa'],
    iso2: 'bw',
    dialCode: '267',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Brazil',
    regions: ['america', 'south-america'],
    iso2: 'br',
    dialCode: '55',
    format: '(..) .........',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'British Indian Ocean Territory',
    regions: ['asia'],
    iso2: 'io',
    dialCode: '246',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'British Virgin Islands',
    regions: ['america', 'carribean'],
    iso2: 'vg',
    dialCode: '1284',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Brunei',
    regions: ['asia'],
    iso2: 'bn',
    dialCode: '673',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Bulgaria',
    regions: ['europe', 'eu-union'],
    iso2: 'bg',
    dialCode: '359',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Burkina Faso',
    regions: ['africa'],
    iso2: 'bf',
    dialCode: '226',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Burundi',
    regions: ['africa'],
    iso2: 'bi',
    dialCode: '257',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Cambodia',
    regions: ['asia'],
    iso2: 'kh',
    dialCode: '855',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Cameroon',
    regions: ['africa'],
    iso2: 'cm',
    dialCode: '237',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Canada',
    regions: ['america', 'north-america'],
    iso2: 'ca',
    dialCode: '1',
    format: '(...) ...-....',
    priority: 1,
    areaCodes: [
      '204',
      '226',
      '236',
      '249',
      '250',
      '289',
      '306',
      '343',
      '365',
      '387',
      '403',
      '416',
      '418',
      '431',
      '437',
      '438',
      '450',
      '506',
      '514',
      '519',
      '548',
      '579',
      '581',
      '587',
      '604',
      '613',
      '639',
      '647',
      '672',
      '705',
      '709',
      '742',
      '778',
      '780',
      '782',
      '807',
      '819',
      '825',
      '867',
      '873',
      '902',
      '905'
    ]
  },
  {
    name: 'Cape Verde',
    regions: ['africa'],
    iso2: 'cv',
    dialCode: '238',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Caribbean Netherlands',
    regions: ['america', 'carribean'],
    iso2: 'bq',
    dialCode: '599',
    format: null,
    priority: 1,
    areaCodes: []
  },
  {
    name: 'Cayman Islands',
    regions: ['america', 'carribean'],
    iso2: 'ky',
    dialCode: '1345',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Central African Republic',
    regions: ['africa'],
    iso2: 'cf',
    dialCode: '236',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Chad',
    regions: ['africa'],
    iso2: 'td',
    dialCode: '235',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Chile',
    regions: ['america', 'south-america'],
    iso2: 'cl',
    dialCode: '56',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'China',
    regions: ['asia'],
    iso2: 'cn',
    dialCode: '86',
    format: '..-.........',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Colombia',
    regions: ['america', 'south-america'],
    iso2: 'co',
    dialCode: '57',
    format: '... ... ....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Comoros',
    regions: ['africa'],
    iso2: 'km',
    dialCode: '269',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Congo (Democratic Republic)',
    regions: ['africa'],
    iso2: 'cd',
    dialCode: '243',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Congo (Republic)',
    regions: ['africa'],
    iso2: 'cg',
    dialCode: '242',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Cook Islands',
    regions: ['oceania'],
    iso2: 'ck',
    dialCode: '682',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Costa Rica',
    regions: ['america', 'central-america'],
    iso2: 'cr',
    dialCode: '506',
    format: '....-....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Côte d’Ivoire',
    regions: ['africa'],
    iso2: 'ci',
    dialCode: '225',
    format: '.. .. .. ..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Croatia',
    regions: ['europe', 'eu-union', 'ex-yugos'],
    iso2: 'hr',
    dialCode: '385',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Cuba',
    regions: ['america', 'carribean'],
    iso2: 'cu',
    dialCode: '53',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Curaçao',
    regions: ['america', 'carribean'],
    iso2: 'cw',
    dialCode: '599',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Cyprus',
    regions: ['europe', 'eu-union'],
    iso2: 'cy',
    dialCode: '357',
    format: '.. ......',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Czech Republic',
    regions: ['europe', 'eu-union'],
    iso2: 'cz',
    dialCode: '420',
    format: '... ... ...',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Denmark',
    regions: ['europe', 'eu-union', 'baltic'],
    iso2: 'dk',
    dialCode: '45',
    format: '.. .. .. ..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Djibouti',
    regions: ['africa'],
    iso2: 'dj',
    dialCode: '253',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Dominica',
    regions: ['america', 'carribean'],
    iso2: 'dm',
    dialCode: '1767',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Dominican Republic',
    regions: ['america', 'carribean'],
    iso2: 'do',
    dialCode: '1',
    format: null,
    priority: 2,
    areaCodes: ['809', '829', '849']
  },
  {
    name: 'Ecuador',
    regions: ['america', 'south-america'],
    iso2: 'ec',
    dialCode: '593',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Egypt',
    regions: ['africa', 'north-africa'],
    iso2: 'eg',
    dialCode: '20',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'El Salvador',
    regions: ['america', 'central-america'],
    iso2: 'sv',
    dialCode: '503',
    format: '....-....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Equatorial Guinea',
    regions: ['africa'],
    iso2: 'gq',
    dialCode: '240',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Eritrea',
    regions: ['africa'],
    iso2: 'er',
    dialCode: '291',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Estonia',
    regions: ['europe', 'eu-union', 'ex-ussr', 'baltic'],
    iso2: 'ee',
    dialCode: '372',
    format: '.... ......',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Ethiopia',
    regions: ['africa'],
    iso2: 'et',
    dialCode: '251',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Falkland Islands',
    regions: ['america', 'south-america'],
    iso2: 'fk',
    dialCode: '500',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Faroe Islands',
    regions: ['europe'],
    iso2: 'fo',
    dialCode: '298',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Fiji',
    regions: ['oceania'],
    iso2: 'fj',
    dialCode: '679',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Finland',
    regions: ['europe', 'eu-union', 'baltic'],
    iso2: 'fi',
    dialCode: '358',
    format: '.. ... .. ..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'France',
    regions: ['europe', 'eu-union'],
    iso2: 'fr',
    dialCode: '33',
    format: '. .. .. .. ..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'French Guiana',
    regions: ['america', 'south-america'],
    iso2: 'gf',
    dialCode: '594',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'French Polynesia',
    regions: ['oceania'],
    iso2: 'pf',
    dialCode: '689',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Gabon',
    regions: ['africa'],
    iso2: 'ga',
    dialCode: '241',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Gambia',
    regions: ['africa'],
    iso2: 'gm',
    dialCode: '220',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Georgia',
    regions: ['asia', 'ex-ussr'],
    iso2: 'ge',
    dialCode: '995',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Germany',
    regions: ['europe', 'eu-union', 'baltic'],
    iso2: 'de',
    dialCode: '49',
    format: '.... ........',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Ghana',
    regions: ['africa'],
    iso2: 'gh',
    dialCode: '233',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Gibraltar',
    regions: ['europe'],
    iso2: 'gi',
    dialCode: '350',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Greece',
    regions: ['europe', 'eu-union'],
    iso2: 'gr',
    dialCode: '30',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Greenland',
    regions: ['america'],
    iso2: 'gl',
    dialCode: '299',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Grenada',
    regions: ['america', 'carribean'],
    iso2: 'gd',
    dialCode: '1473',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Guadeloupe',
    regions: ['america', 'carribean'],
    iso2: 'gp',
    dialCode: '590',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Guam',
    regions: ['oceania'],
    iso2: 'gu',
    dialCode: '1671',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Guatemala',
    regions: ['america', 'central-america'],
    iso2: 'gt',
    dialCode: '502',
    format: '....-....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Guinea',
    regions: ['africa'],
    iso2: 'gn',
    dialCode: '224',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Guinea-Bissau',
    regions: ['africa'],
    iso2: 'gw',
    dialCode: '245',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Guyana',
    regions: ['america', 'south-america'],
    iso2: 'gy',
    dialCode: '592',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Haiti',
    regions: ['america', 'carribean'],
    iso2: 'ht',
    dialCode: '509',
    format: '....-....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Honduras',
    regions: ['america', 'central-america'],
    iso2: 'hn',
    dialCode: '504',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Hong Kong',
    regions: ['asia'],
    iso2: 'hk',
    dialCode: '852',
    format: '.... ....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Hungary',
    regions: ['europe', 'eu-union'],
    iso2: 'hu',
    dialCode: '36',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Iceland',
    regions: ['europe'],
    iso2: 'is',
    dialCode: '354',
    format: '... ....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'India',
    regions: ['asia'],
    iso2: 'in',
    dialCode: '91',
    format: '.....-.....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Indonesia',
    regions: ['asia'],
    iso2: 'id',
    dialCode: '62',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Iran',
    regions: ['middle-east'],
    iso2: 'ir',
    dialCode: '98',
    format: '... ... ....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Iraq',
    regions: ['middle-east'],
    iso2: 'iq',
    dialCode: '964',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Ireland',
    regions: ['europe', 'eu-union'],
    iso2: 'ie',
    dialCode: '353',
    format: '.. .......',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Israel',
    regions: ['middle-east'],
    iso2: 'il',
    dialCode: '972',
    format: '... ... ....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Italy',
    regions: ['europe', 'eu-union'],
    iso2: 'it',
    dialCode: '39',
    format: '... .......',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Jamaica',
    regions: ['america', 'carribean'],
    iso2: 'jm',
    dialCode: '1876',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Japan',
    regions: ['asia'],
    iso2: 'jp',
    dialCode: '81',
    format: '.. .... ....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Jersey',
    regions: ['europe', 'eu-union'],
    iso2: 'je',
    dialCode: '44',
    format: '.... ......',
    priority: 1,
    areaCodes: []
  },
  {
    name: 'Jordan',
    regions: ['middle-east'],
    iso2: 'jo',
    dialCode: '962',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Kazakhstan',
    regions: ['asia', 'ex-ussr'],
    iso2: 'kz',
    dialCode: '7',
    format: '... ...-..-..',
    priority: 1,
    areaCodes: [
      '310',
      '311',
      '312',
      '313',
      '315',
      '318',
      '321',
      '324',
      '325',
      '326',
      '327',
      '336',
      '7172',
      '73622'
    ]
  },
  {
    name: 'Kenya',
    regions: ['africa'],
    iso2: 'ke',
    dialCode: '254',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Kiribati',
    regions: ['oceania'],
    iso2: 'ki',
    dialCode: '686',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Kosovo',
    regions: ['europe', 'ex-yugos'],
    iso2: 'xk',
    dialCode: '383',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Kuwait',
    regions: ['middle-east'],
    iso2: 'kw',
    dialCode: '965',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Kyrgyzstan',
    regions: ['asia', 'ex-ussr'],
    iso2: 'kg',
    dialCode: '996',
    format: '... ... ...',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Laos',
    regions: ['asia'],
    iso2: 'la',
    dialCode: '856',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Latvia',
    regions: ['europe', 'eu-union', 'ex-ussr', 'baltic'],
    iso2: 'lv',
    dialCode: '371',
    format: '.. ... ...',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Lebanon',
    regions: ['middle-east'],
    iso2: 'lb',
    dialCode: '961',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Lesotho',
    regions: ['africa'],
    iso2: 'ls',
    dialCode: '266',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Liberia',
    regions: ['africa'],
    iso2: 'lr',
    dialCode: '231',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Libya',
    regions: ['africa', 'north-africa'],
    iso2: 'ly',
    dialCode: '218',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Liechtenstein',
    regions: ['europe'],
    iso2: 'li',
    dialCode: '423',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Lithuania',
    regions: ['europe', 'eu-union', 'ex-ussr', 'baltic'],
    iso2: 'lt',
    dialCode: '370',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Luxembourg',
    regions: ['europe', 'eu-union'],
    iso2: 'lu',
    dialCode: '352',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Macau',
    regions: ['asia'],
    iso2: 'mo',
    dialCode: '853',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Macedonia',
    regions: ['europe', 'ex-yugos'],
    iso2: 'mk',
    dialCode: '389',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Madagascar',
    regions: ['africa'],
    iso2: 'mg',
    dialCode: '261',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Malawi',
    regions: ['africa'],
    iso2: 'mw',
    dialCode: '265',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Malaysia',
    regions: ['asia'],
    iso2: 'my',
    dialCode: '60',
    format: '..-....-....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Maldives',
    regions: ['asia'],
    iso2: 'mv',
    dialCode: '960',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Mali',
    regions: ['africa'],
    iso2: 'ml',
    dialCode: '223',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Malta',
    regions: ['europe', 'eu-union'],
    iso2: 'mt',
    dialCode: '356',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Marshall Islands',
    regions: ['oceania'],
    iso2: 'mh',
    dialCode: '692',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Martinique',
    regions: ['america', 'carribean'],
    iso2: 'mq',
    dialCode: '596',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Mauritania',
    regions: ['africa'],
    iso2: 'mr',
    dialCode: '222',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Mauritius',
    regions: ['africa'],
    iso2: 'mu',
    dialCode: '230',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Mexico',
    regions: ['america', 'central-america'],
    iso2: 'mx',
    dialCode: '52',
    format: '... ... ....',
    priority: 0,
    areaCodes: ['55', '81', '33', '656', '664', '998', '774', '229']
  },
  {
    name: 'Micronesia',
    regions: ['oceania'],
    iso2: 'fm',
    dialCode: '691',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Moldova',
    regions: ['europe'],
    iso2: 'md',
    dialCode: '373',
    format: '(..) ..-..-..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Monaco',
    regions: ['europe'],
    iso2: 'mc',
    dialCode: '377',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Mongolia',
    regions: ['asia'],
    iso2: 'mn',
    dialCode: '976',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Montenegro',
    regions: ['europe', 'ex-yugos'],
    iso2: 'me',
    dialCode: '382',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Montserrat',
    regions: ['america', 'carribean'],
    iso2: 'ms',
    dialCode: '1664',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Morocco',
    regions: ['africa', 'north-africa'],
    iso2: 'ma',
    dialCode: '212',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Mozambique',
    regions: ['africa'],
    iso2: 'mz',
    dialCode: '258',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Myanmar',
    regions: ['asia'],
    iso2: 'mm',
    dialCode: '95',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Namibia',
    regions: ['africa'],
    iso2: 'na',
    dialCode: '264',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Nauru',
    regions: ['africa'],
    iso2: 'nr',
    dialCode: '674',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Nepal',
    regions: ['asia'],
    iso2: 'np',
    dialCode: '977',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Netherlands',
    regions: ['europe', 'eu-union'],
    iso2: 'nl',
    dialCode: '31',
    format: '.. ........',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'New Caledonia',
    regions: ['oceania'],
    iso2: 'nc',
    dialCode: '687',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'New Zealand',
    regions: ['oceania'],
    iso2: 'nz',
    dialCode: '64',
    format: '...-...-....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Nicaragua',
    regions: ['america', 'central-america'],
    iso2: 'ni',
    dialCode: '505',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Niger',
    regions: ['africa'],
    iso2: 'ne',
    dialCode: '227',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Nigeria',
    regions: ['africa'],
    iso2: 'ng',
    dialCode: '234',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Niue',
    regions: ['asia'],
    iso2: 'nu',
    dialCode: '683',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Norfolk Island',
    regions: ['oceania'],
    iso2: 'nf',
    dialCode: '672',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'North Korea',
    regions: ['asia'],
    iso2: 'kp',
    dialCode: '850',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Northern Mariana Islands',
    regions: ['oceania'],
    iso2: 'mp',
    dialCode: '1670',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Norway',
    regions: ['europe', 'baltic'],
    iso2: 'no',
    dialCode: '47',
    format: '... .. ...',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Oman',
    regions: ['middle-east'],
    iso2: 'om',
    dialCode: '968',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Pakistan',
    regions: ['asia'],
    iso2: 'pk',
    dialCode: '92',
    format: '...-.......',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Palau',
    regions: ['oceania'],
    iso2: 'pw',
    dialCode: '680',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Palestine',
    regions: ['middle-east'],
    iso2: 'ps',
    dialCode: '970',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Panama',
    regions: ['america', 'central-america'],
    iso2: 'pa',
    dialCode: '507',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Papua New Guinea',
    regions: ['oceania'],
    iso2: 'pg',
    dialCode: '675',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Paraguay',
    regions: ['america', 'south-america'],
    iso2: 'py',
    dialCode: '595',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Peru',
    regions: ['america', 'south-america'],
    iso2: 'pe',
    dialCode: '51',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Philippines',
    regions: ['asia'],
    iso2: 'ph',
    dialCode: '63',
    format: '.... .......',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Poland',
    regions: ['europe', 'eu-union', 'baltic'],
    iso2: 'pl',
    dialCode: '48',
    format: '...-...-...',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Portugal',
    regions: ['europe', 'eu-union'],
    iso2: 'pt',
    dialCode: '351',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Puerto Rico',
    regions: ['america', 'carribean'],
    iso2: 'pr',
    dialCode: '1',
    format: null,
    priority: 3,
    areaCodes: ['787', '939']
  },
  {
    name: 'Qatar',
    regions: ['middle-east'],
    iso2: 'qa',
    dialCode: '974',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Réunion',
    regions: ['africa'],
    iso2: 're',
    dialCode: '262',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Romania',
    regions: ['europe', 'eu-union'],
    iso2: 'ro',
    dialCode: '40',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Russia',
    regions: ['europe', 'asia', 'ex-ussr', 'baltic'],
    iso2: 'ru',
    dialCode: '7',
    format: '(...) ...-..-..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Rwanda',
    regions: ['africa'],
    iso2: 'rw',
    dialCode: '250',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Saint Barthélemy',
    regions: ['america', 'carribean'],
    iso2: 'bl',
    dialCode: '590',
    format: null,
    priority: 1,
    areaCodes: []
  },
  {
    name: 'Saint Helena',
    regions: ['africa'],
    iso2: 'sh',
    dialCode: '290',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Saint Kitts and Nevis',
    regions: ['america', 'carribean'],
    iso2: 'kn',
    dialCode: '1869',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Saint Lucia',
    regions: ['america', 'carribean'],
    iso2: 'lc',
    dialCode: '1758',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Saint Martin',
    regions: ['america', 'carribean'],
    iso2: 'mf',
    dialCode: '590',
    format: null,
    priority: 2,
    areaCodes: []
  },
  {
    name: 'Saint Pierre and Miquelon',
    regions: ['america', 'north-america'],
    iso2: 'pm',
    dialCode: '508',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Saint Vincent and the Grenadines',
    regions: ['america', 'carribean'],
    iso2: 'vc',
    dialCode: '1784',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Samoa',
    regions: ['oceania'],
    iso2: 'ws',
    dialCode: '685',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'San Marino',
    regions: ['europe'],
    iso2: 'sm',
    dialCode: '378',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'São Tomé and Príncipe',
    regions: ['africa'],
    iso2: 'st',
    dialCode: '239',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Saudi Arabia',
    regions: ['middle-east'],
    iso2: 'sa',
    dialCode: '966',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Senegal',
    regions: ['africa'],
    iso2: 'sn',
    dialCode: '221',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Serbia',
    regions: ['europe', 'ex-yugos'],
    iso2: 'rs',
    dialCode: '381',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Seychelles',
    regions: ['africa'],
    iso2: 'sc',
    dialCode: '248',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Sierra Leone',
    regions: ['africa'],
    iso2: 'sl',
    dialCode: '232',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Singapore',
    regions: ['asia'],
    iso2: 'sg',
    dialCode: '65',
    format: '....-....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Sint Maarten',
    regions: ['america', 'carribean'],
    iso2: 'sx',
    dialCode: '1721',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Slovakia',
    regions: ['europe', 'eu-union'],
    iso2: 'sk',
    dialCode: '421',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Slovenia',
    regions: ['europe', 'eu-union', 'ex-yugos'],
    iso2: 'si',
    dialCode: '386',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Solomon Islands',
    regions: ['oceania'],
    iso2: 'sb',
    dialCode: '677',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Somalia',
    regions: ['africa'],
    iso2: 'so',
    dialCode: '252',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'South Africa',
    regions: ['africa'],
    iso2: 'za',
    dialCode: '27',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'South Korea',
    regions: ['asia'],
    iso2: 'kr',
    dialCode: '82',
    format: '... .... ....',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'South Sudan',
    regions: ['africa', 'north-africa'],
    iso2: 'ss',
    dialCode: '211',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Spain',
    regions: ['europe', 'eu-union'],
    iso2: 'es',
    dialCode: '34',
    format: '... ... ...',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Sri Lanka',
    regions: ['asia'],
    iso2: 'lk',
    dialCode: '94',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Sudan',
    regions: ['africa'],
    iso2: 'sd',
    dialCode: '249',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Suriname',
    regions: ['america', 'south-america'],
    iso2: 'sr',
    dialCode: '597',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Swaziland',
    regions: ['africa'],
    iso2: 'sz',
    dialCode: '268',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Sweden',
    regions: ['europe', 'eu-union', 'baltic'],
    iso2: 'se',
    dialCode: '46',
    format: '(...) ...-...',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Switzerland',
    regions: ['europe'],
    iso2: 'ch',
    dialCode: '41',
    format: '.. ... .. ..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Syria',
    regions: ['middle-east'],
    iso2: 'sy',
    dialCode: '963',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Taiwan',
    regions: ['asia'],
    iso2: 'tw',
    dialCode: '886',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Tajikistan',
    regions: ['asia', 'ex-ussr'],
    iso2: 'tj',
    dialCode: '992',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Tanzania',
    regions: ['africa'],
    iso2: 'tz',
    dialCode: '255',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Thailand',
    regions: ['asia'],
    iso2: 'th',
    dialCode: '66',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Timor-Leste',
    regions: ['asia'],
    iso2: 'tl',
    dialCode: '670',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Togo',
    regions: ['africa'],
    iso2: 'tg',
    dialCode: '228',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Tokelau',
    regions: ['oceania'],
    iso2: 'tk',
    dialCode: '690',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Tonga',
    regions: ['oceania'],
    iso2: 'to',
    dialCode: '676',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Trinidad and Tobago',
    regions: ['america', 'carribean'],
    iso2: 'tt',
    dialCode: '1868',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Tunisia',
    regions: ['africa', 'north-africa'],
    iso2: 'tn',
    dialCode: '216',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Turkey',
    regions: ['europe'],
    iso2: 'tr',
    dialCode: '90',
    format: '... ... .. ..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Turkmenistan',
    regions: ['asia', 'ex-ussr'],
    iso2: 'tm',
    dialCode: '993',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Turks and Caicos Islands',
    regions: ['america', 'carribean'],
    iso2: 'tc',
    dialCode: '1649',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Tuvalu',
    regions: ['asia'],
    iso2: 'tv',
    dialCode: '688',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'U.S. Virgin Islands',
    regions: ['america', 'carribean'],
    iso2: 'vi',
    dialCode: '1340',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Uganda',
    regions: ['africa'],
    iso2: 'ug',
    dialCode: '256',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Ukraine',
    regions: ['europe', 'ex-ussr'],
    iso2: 'ua',
    dialCode: '380',
    format: '(..) ... .. ..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'United Arab Emirates',
    regions: ['middle-east'],
    iso2: 'ae',
    dialCode: '971',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'United Kingdom',
    regions: ['europe', 'eu-union'],
    iso2: 'gb',
    dialCode: '44',
    format: '.... ......',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'United States',
    regions: ['america', 'north-america'],
    iso2: 'us',
    dialCode: '1',
    format: '(...) ...-....',
    priority: 0,
    areaCodes: [
      '907',
      '205',
      '251',
      '256',
      '334',
      '479',
      '501',
      '870',
      '480',
      '520',
      '602',
      '623',
      '928',
      '209',
      '213',
      '310',
      '323',
      '408',
      '415',
      '510',
      '530',
      '559',
      '562',
      '619',
      '626',
      '650',
      '661',
      '707',
      '714',
      '760',
      '805',
      '818',
      '831',
      '858',
      '909',
      '916',
      '925',
      '949',
      '951',
      '303',
      '719',
      '970',
      '203',
      '860',
      '202',
      '302',
      '239',
      '305',
      '321',
      '352',
      '386',
      '407',
      '561',
      '727',
      '772',
      '813',
      '850',
      '863',
      '904',
      '941',
      '954',
      '229',
      '404',
      '478',
      '706',
      '770',
      '912',
      '808',
      '319',
      '515',
      '563',
      '641',
      '712',
      '208',
      '217',
      '309',
      '312',
      '618',
      '630',
      '708',
      '773',
      '815',
      '847',
      '219',
      '260',
      '317',
      '574',
      '765',
      '812',
      '316',
      '620',
      '785',
      '913',
      '270',
      '502',
      '606',
      '859',
      '225',
      '318',
      '337',
      '504',
      '985',
      '413',
      '508',
      '617',
      '781',
      '978',
      '301',
      '410',
      '207',
      '231',
      '248',
      '269',
      '313',
      '517',
      '586',
      '616',
      '734',
      '810',
      '906',
      '989',
      '218',
      '320',
      '507',
      '612',
      '651',
      '763',
      '952',
      '314',
      '417',
      '573',
      '636',
      '660',
      '816',
      '228',
      '601',
      '662',
      '406',
      '252',
      '336',
      '704',
      '828',
      '910',
      '919',
      '701',
      '308',
      '402',
      '603',
      '201',
      '609',
      '732',
      '856',
      '908',
      '973',
      '505',
      '575',
      '702',
      '775',
      '212',
      '315',
      '516',
      '518',
      '585',
      '607',
      '631',
      '716',
      '718',
      '845',
      '914',
      '216',
      '330',
      '419',
      '440',
      '513',
      '614',
      '740',
      '937',
      '405',
      '580',
      '918',
      '503',
      '541',
      '215',
      '412',
      '570',
      '610',
      '717',
      '724',
      '814',
      '401',
      '803',
      '843',
      '864',
      '605',
      '423',
      '615',
      '731',
      '865',
      '901',
      '931',
      '210',
      '214',
      '254',
      '281',
      '325',
      '361',
      '409',
      '432',
      '512',
      '713',
      '806',
      '817',
      '830',
      '903',
      '915',
      '936',
      '940',
      '956',
      '972',
      '979',
      '435',
      '801',
      '276',
      '434',
      '540',
      '703',
      '757',
      '804',
      '802',
      '206',
      '253',
      '360',
      '425',
      '509',
      '262',
      '414',
      '608',
      '715',
      '920',
      '304',
      '307'
    ]
  },
  {
    name: 'Uruguay',
    regions: ['america', 'south-america'],
    iso2: 'uy',
    dialCode: '598',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Uzbekistan',
    regions: ['asia', 'ex-ussr'],
    iso2: 'uz',
    dialCode: '998',
    format: '.. ... .. ..',
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Vanuatu',
    regions: ['oceania'],
    iso2: 'vu',
    dialCode: '678',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Vatican City',
    regions: ['europe'],
    iso2: 'va',
    dialCode: '39',
    format: '.. .... ....',
    priority: 1,
    areaCodes: []
  },
  {
    name: 'Venezuela',
    regions: ['america', 'south-america'],
    iso2: 've',
    dialCode: '58',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Vietnam',
    regions: ['asia'],
    iso2: 'vn',
    dialCode: '84',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Wallis and Futuna',
    regions: ['oceania'],
    iso2: 'wf',
    dialCode: '681',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Yemen',
    regions: ['middle-east'],
    iso2: 'ye',
    dialCode: '967',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Zambia',
    regions: ['africa'],
    iso2: 'zm',
    dialCode: '260',
    format: null,
    priority: 0,
    areaCodes: []
  },
  {
    name: 'Zimbabwe',
    regions: ['africa'],
    iso2: 'zw',
    dialCode: '263',
    format: null,
    priority: 0,
    areaCodes: []
  }
]
